'use strict';
import { observable, action } from 'mobx';
import { fetch, buildUrl } from '@/lib/fetchAPI';
import history from '@/lib/history';
import globalStore from '../Global';

class DeviceGroupStore {
  @observable deviceGroupArr = [];
  @observable deviceGroupListArr = [];
  @observable modalStatus = false;

  @action
  loadDeviceGroup(groupName) {
    let param = buildUrl({ group_name: groupName });
    fetch(`/api/tag${param}`, { method: 'GET' }, json => {
      this.deviceGroupArr = [...json].map((item, index) => {
        item.key = index + 1;
        return item;
      });
    });
  }

  @action.bound
  loadGroupList(deviceId) {
    let param = buildUrl({ tag_id: deviceId, page_num: 1, page_size: 1000000 });
    fetch(`/api/tag/device/list${param}`, { method: 'GET' }, json => {
      this.deviceGroupListArr = [...json.content].map((item, index) => {
        item.key = index + 1;
        return item;
      });
    });
    this.modalStatus = true;
  }
  @action.bound
  hideModal() {
    this.modalStatus = false;
  }

  deleteGroup(groupId) {
    return fetch(
      `/api/tag?tag_id=${groupId}`,
      { method: 'DELETE' },
      json => json
    );
  }
}
export default new DeviceGroupStore();



// WEBPACK FOOTER //
// ./src/store/DeviceGroup/DeviceGroup.js